import * as Yup from "yup";
import calculateRatesFormModel from "./form-model";

const {
  formFields: { weight, destinationZip, originatingZip, dropoffPickup },
} = calculateRatesFormModel;

const validationSchema = Yup.object({
  [weight.name]: Yup.number()
    .required(weight.errorMsg.required)
    .positive(weight.errorMsg.positive)
    .moreThan(0, weight.errorMsg.min)
    .max(150, weight.errorMsg.max),
  [originatingZip.name]: Yup.string()
    .required(originatingZip.errorMsg.required)
    .matches(/(^\d{5}$)|(^\d{5}-\d{4}$)/, originatingZip.errorMsg.invalid),
  [destinationZip.name]: Yup.string()
    .required(destinationZip.errorMsg.required)
    .matches(/(^\d{5}$)|(^\d{5}-\d{4}$)/, destinationZip.errorMsg.invalid),
  [dropoffPickup.name]: Yup.string().required(dropoffPickup.errorMsg.required),
});

export default validationSchema;
